<template>
  <div class="position-box">
    <div class="head">
      <div class="back-box" @click="goBack">
        <img class="icon" src="@/assets/icon_back.png" alt="back" />
      </div>
      <!-- <div>{{ $t("gjrz.title") }}</div> -->
    </div>
    <div class="cotainer">
      <div class="login-box">
        <div class="logo-box"><img class="logo" :src="webLogo" alt=""></div>
        <div class="title">{{webTitle}}</div>
      </div>
      <div class="tips">{{ $t("sztxmm.zh") }}</div>
      <div class="input-box">
        <input class="input" v-model="userName" type="text" :placeholder="$t('gjrz.qsrzh')" autocomplete="off"/>
      </div>
      <div class="tips">{{ $t("sztkmm.dlmm") }}</div>
      <div class="input-box">
        <input class="input" v-model="passwords" type="password" :placeholder="$t('sztkmm.dlmmts')" autocomplete="off"/>
      </div>
      <div class="btn-login btn-bg" @click="submit">{{ $t("gjrz.dl") }}</div>
      <div class="btn-login btn-login2 btn-bg" @click="loginWallet">{{ $t("newReg.qbdl") }}</div>
      <div tag="div" class="t1">{{$t('newReg.hmyzh')}}<router-link class="t2" tag="span" to="/reg">{{$t('newReg.qzc')}}</router-link></div>
    </div>

  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
export default {
  name: "login",
  data() {
    return {
      lang: "en",
      token: "",
      userName: '',
      passwords: '',
      index: 0,
      address: '',
      isInnerUser: false,
      isMn: false,
      count: 1,
    };
  },
  mounted() {
    this.userName = localStorage.getItem('account') || '';
    this.passwords = localStorage.getItem('pwd') || '';
    this.isInnerUser = localStorage.getItem('isInnerUser') || false;
    this.isMn = JSON.parse(sessionStorage.getItem('isMn'));
  },
  methods: {
    goBack() {
      this.$router.push("/index");
    },
    loginWallet(){
      if(window.ethereum || (window.trustwallet && window.trustwallet.ethereum)) {
        this.getAddress();
      }else{
        MessageBox({
          title: '',
          message: this.$t("newReg.qbdl"),
          showCancelButton:true,
          confirmButtonText:this.$t("打开")+'APP',
          cancelButtonText:this.$t("下载"),
        }).then(action => {
          if(action == 'confirm'){
            window.location.href = 'dfw://wc?uri=wc%3A60d993114ce6fb772cf28dc653b2e2092e3f40e44648b174d55ba295778c619a%402%3FexpiryTimestamp%3D1729603043%26relay-protocol%3Dirn%26symKey%3D9d2da13698bdda66a5a4a40cca6b1580f49b21cb7ad6d68f6db7c7fcad7c1a10';
          }else{
            window.location.href = this.jumpUrl;
            // window.location.href = 'https://crypto.com/defi-wallet';
          }
        });
      }
    },
    async getAddress() {
      var that = this;
      let web3Provider = null;
      if (window.ethereum) {
        web3Provider = window.ethereum;
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
        } catch (error) {
          console.error("User denied account access");
          return false;
        }
      } else if (window.web3) {
        web3Provider = window.web3.currentProvider;
      } else {
        web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
      }
      if (web3Provider) {
        const Web3address = new Web3(web3Provider);
        try {
          const accounts = await Web3address.eth.getAccounts();
          const address = accounts[0];
          if (address) {
            that.address = address;
            localStorage.setItem("ethAddress", address);
            that.getEthLogin();
          } else {
            if(!that.isInnerUser){
              if(window.ethereum){
                that.$toast.center(that.$t("langNew2.ljdzsb"));
              }
            }
          }
        } catch (error) {
          if(!that.isInnerUser){
            if(window.ethereum){
              that.$toast.center(that.$t("langNew2.ljdzsb"));
            }
          }
        }
      } else {
        if(!that.isInnerUser){
          if(window.ethereum){
            that.$toast.center(that.$t("langNew2.ljdzsb"));
          }
        }
      }
    },
    getEthLogin(){//获取地址
      let params = {
          address: this.address
      }
      this.$ajax.get('/web/ethLogin',{params}).then((res) => {
        let resData = res.data.data;
        if(res.data.code == 0){
          if(this.isMn || this.isInnerUser) return;
          this.token = resData.token;
          localStorage.setItem('token',resData.token);
          localStorage.setItem('userID',resData.id);
          // 传递顾客信息
          _MEIQIA('metadata', {
            uid: resData.id, // 自定义字段
            name: resData.id, // 美洽默认字段
          });
          var url = window.location.protocol + '//' + window.location.host;
          window.location.href = url;
        }else{
          // this.$toast.center(res.data.message);
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    submit() {
      if (!this.userName) {
        this.$toast.center(this.$t("gjrz.qsrzh"));
        return false;
      }
      if(!this.passwords) {
        this.$toast.center(this.$t('sztkmm.dlmmts'));
        return false;
      }
      if(this.userName.indexOf('@') > 0){
          this.index = 1
      }else{
          this.index = 0
      }
      let params = {
          account: this.userName,
          password: this.passwords,
          index: this.index,
          sms_code: '',
          token: 1
      }
      if (this.count == 1) {
        this.count = 0;
      } else {
        return false;
      }
      this.$ajax.post('/web/userLogin',params).then((res) => {
        let resData = res.data;
        if(resData.code == 0 || resData.code == 4 || resData.code == 7){
            localStorage.setItem('token',resData.data.token);
            localStorage.setItem('account',this.userName);
            localStorage.setItem('pwd',this.passwords);
            localStorage.setItem('userID',resData.data.id);
            localStorage.setItem('isInnerUser',true);
            localStorage.setItem('userInfo',JSON.stringify(resData.data));
            // 传递顾客信息
            _MEIQIA('metadata', {
              uid: resData.data.id, // 自定义字段
              name: resData.data.id,
            });
            this.count = 1;
            setTimeout(() => {
              this.$router.push('/index')
            }, 1000)
        }else{
          this.count = 1;
          this.$toast.center(resData.message);
          return;
        }
      }).catch(function(err){
          console.log(err)
      })
    },
  },
  filters: {

  },
};
</script>
<style scoped>
.position-box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  color: #cecece;
  font-size: 0.36rem;
  background: url("../assets/element-background.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}
.center {
  text-align: center;
}
.head {
  position: relative;
  height: 1.2rem;
  font-size: 0.52rem;
  line-height: 1.2rem;
  /* background: #0e1530; */
  text-align: center;
}
.head .icon {
  position: absolute;
  left: 0.3rem;
  top: 0.3rem;
  width: 0.32rem;
  height: 0.6rem;
}
.cotainer {
  position: absolute;
  left: 0.4rem;
  right: 0.4rem;
  top: 1.2rem;
  bottom: 0;
  /* background: #fff; */
  overflow-y: scroll;
}
.cotainer .tips {
  padding: 0.54rem 0 0.26rem;
  color: #fff;
  font-size: 0.4rem;
}
.login-box{
  margin: .5rem auto;
  text-align: center;
}
.login-box .logo{
  width: 2.5rem;
  height: 2.5rem;
}
.login-box .title{
  padding: .2rem 0 0;
  color: #fff;
  font-size: .56rem;
}
.cotainer .input-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.32rem 0;
  border: 0.01rem solid #515151;
  border-radius: 6px;
}
.cotainer .input-pwd {
  margin-top: 0.76rem;
}
.cotainer .input-box .input {
  flex: 1;
  height: 100%;
  padding: 0 0.2rem;
  color: #fff;
  font-size: 0.42rem;
}
.cotainer .input-box .input::placeholder {
  color: #d7d7d7;
  font-size: 0.42rem;
}
.cotainer .input-box .code {
  color: #588bf8;
  font-size: 0.48rem;
}
.btn-login {
  width: 100%;
  margin-top: 1rem;
}
.btn-login2 {
  border: 1px solid #515151;
  background: transparent;
}
.cotainer .t1{
  padding: 1rem 0 .4rem;
  color: #acacac;
  font-size: .4rem;
}
.cotainer .t2{
  color: #588bf8;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue